import { render, staticRenderFns } from "./course_knowledge_points.vue?vue&type=template&id=1d856a88&scoped=true&"
import script from "./course_knowledge_points.vue?vue&type=script&lang=js&"
export * from "./course_knowledge_points.vue?vue&type=script&lang=js&"
import style0 from "./course_knowledge_points.vue?vue&type=style&index=0&id=1d856a88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d856a88",
  null
  
)

export default component.exports